import { Form, FormItem, useForm } from '@/commons/components/Form';
import TagsField from '@/commons/components/Form/TagsField';
import { FileModel } from '@/types';
import { EditOutlined } from '@ant-design/icons';
import { Button, Input, Modal } from 'antd';
import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';

type Props = {
  item: FileModel;
};
const FileItemEditorModal: FC<Props> = (props: Props) => {
  const { item } = props;
  const storageEntityDispatch = useDispatch();
  const [form] = useForm();
  const [visible, setVisible] = useState(false);
  const handleSubmit = () => {
    form.submit();
  };
  const handleFinish = (values: FileModel) => {
    storageEntityDispatch.save(values);
    setVisible(false);
  };
  return (
    <>
      <div className="image__edit" style={{ marginRight: 10 }}>
        <Button icon={<EditOutlined />} onClick={() => setVisible(!visible)} />
      </div>
      <Modal
        title={`Edit ${item.code}`}
        open={visible}
        onCancel={() => setVisible(false)}
        onOk={handleSubmit}
      >
        {visible && (
          <Form
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            form={form}
            onFinish={handleFinish}
            initialValues={{ ...item }}
          >
            <FormItem name="id" hidden>
              <Input type="hidden" />
            </FormItem>
            <FormItem name="originalName" label="Name">
              <Input placeholder="name" />
            </FormItem>
            <FormItem name="alt" label="Alt">
              <Input placeholder="alt" />
            </FormItem>
            <FormItem name="tags" label="Tags">
              <TagsField placeholder="tags" />
            </FormItem>
          </Form>
        )}
      </Modal>
    </>
  );
};

export default FileItemEditorModal;
